import { createApp } from 'vue'
import PodcastSliderCard from './PodcastSliderCard'

const el = '.kb-component--podcast-slider-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((PodcastSliderCardDom) => {
            const data = PodcastSliderCardDom.dataset.data
                ? JSON.parse(PodcastSliderCardDom.dataset.data)
                : null

            const component = createApp(PodcastSliderCard, { data }).use(Store)
            component.mount(PodcastSliderCardDom)
        })
    }
}
